import React from "react"

import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"
import CheckoutSummary from "~components/pages/listing/checkout/checkout-summary"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import COPY from "~config/copy-constants"

export default function CheckoutFlowSummaryStep() {
    const { quote } = useCheckoutFlow()

    const error = quote ? null : new Error(COPY.UNABLE_TO_FIND_QUOTE)

    return (
        <LoadingOrErrorContainer error={error} shouldRenderChildren>
            {quote && <CheckoutSummary quote={quote} />}
        </LoadingOrErrorContainer>
    )
}
